import { ReactNode } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import MUIDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

interface DialogTitleProps {
  id: string;
  children?: ReactNode;
  onClose: () => void;
  closeDisabled?: boolean;
}

const DialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, closeDisabled, ...other } = props;
  const { t } = useTranslation();
  return (
    <MUIDialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label={t('base.close')}
          onClick={onClose}
          disabled={closeDisabled}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MUIDialogTitle>
  );
};

export default DialogTitle;
